import React, { Fragment, useEffect, useState } from "react";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { connect } from "react-redux";
import Select from "react-select";

const CountryForm = (props) => {
  const values = [
    { value: 1, label: "UAE" },
    { value: 2, label: "KSA" },
    { value: 3, label: "Egypt" },
  ];
  const [country, setCountry] = useState(values[0]);

  const handleChange = (c) => {
    setCountry(c);
  };

  const nextClick = () => {
    props.set_store({
      store: { ...props.store, country_id: country.value },
    });
    props.set_page_state({ pageState: { id: 3 } });
  };
  useEffect(() => {
    props.store.country_id && setCountry(values[props.store.country_id - 1]);
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <form className="form mx-auto">
        <label>Select Country</label>
        <Select
          value={country}
          onChange={handleChange}
          options={values}
          placeholder="Select Country"
          className="country-select"
          classNamePrefix="control"
          isSearchable={false}
        />
        <br />
        <button type="button" className="next-button" onClick={nextClick}>
          Next
        </button>
      </form>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pageState: state.pageState.pageState,
    store: state.store.store,
  };
};

const mapDispatchTopProps = { set_store, set_page_state };

export default connect(mapStateToProps, mapDispatchTopProps)(CountryForm);
